import {
  MOVEMENT_TYPES
} from "@hub/order/src/constants"
import {
  CATEGORY_TYPES,
  PORTABILITY,
  SERVICES_TYPES,
  SERVICE_STATUS,
  SERVICE_STATUS_NAME
} from "@hub/audit/src/constants"

export default {
  orderToAudit: state => state.orderToAudit,
  orderToView: state => state.orderToView,
  isViewOnly: state => state.isViewOnly,
  isEditingData: state => state.isEditingData,
  isEditingFinishedOrder: state => state.isEditingFinishedOrder,
  isAuditActionsLocked: state => state.isViewOnly || state.isEditingFinishedOrder,
  currentStep: state => state.currentStep,
  loading: state => state.loading,
  getIndexStepsAlreadyVisited: state => state.indexStepsAlreadyVisited,
  getCurrentSteps: state => state.currentSteps,
  order: state => state.order,
  orderPermissions: state => state.order?.permissions,
  client: state => ({
    ...state.client,
    complement: state.order?.customer?.address?.complement || []
  }),
  biometry: state => state.biometry,
  products: state => state.products,
  billing: state => state.billing,
  contract: state => state.contract,
  coverage: state => state.coverage,
  credit: state => state.credit,
  installation: state => state.installation,
  showPrintOrder: state => state.showPrintOrder,
  getOptionsStatusReasons: state => state.optionsStatusReasons,
  getOptionsServicesStatus: state => state.optionsServicesStatus,
  orderCustomer: state => state.order?.customer,
  orderCustomerAddress: (state, getters) => getters.orderCustomer?.address,
  orderCustomerChargeAddress: (state, getters) =>
    getters.orderCustomer?.charge_address,
  getIsRouteReady: state => state.isRouteReady,
  coverageDetail: state => state.coverageDetail,
  orderCustomerTypeAddress: state => state.order?.location_type,
  getProductBillingDiscount: state => state.productBillingDiscount,
  getHasChangeShippingMethod: state => state.hasChangeShippingMethod,
  getHasChangePaymentMethod: state => state.hasChangePaymentMethod,
  getAuditFlow: state => state.auditFlow,
  getCommission: state => state.commission,

  statusApproved: () => {
    return SERVICE_STATUS.find(
      status => status.text === SERVICE_STATUS_NAME.approved
    )?.value
  },

  statusReproved: () => {
    return SERVICE_STATUS.find(
      status => status.text === SERVICE_STATUS_NAME.reproved
    )?.value
  },

  statusRemoved: () => {
    return SERVICE_STATUS.find(
      status => status.text === SERVICE_STATUS_NAME.removed
    )?.value
  },

  statusWaiting: () => {
    return SERVICE_STATUS.find(
      status => status.text === SERVICE_STATUS_NAME.awaiting
    )?.value
  },

  getItemFromMovemenIfNecessary: () => (product, key) => {
    const FIRST_MOVEMENT = product.properties?.movements[0] || {}

    return product[key] != undefined
      ? product[key]
      : FIRST_MOVEMENT[key] || ""
  },

  getMovementPayload: (state, getters) => product => {
    const FIRST_MOVEMENT = product.properties?.movements[0] || {}
    const ICCID = getters.getItemFromMovemenIfNecessary(product, "iccid")
    const LINE_NUMBER = getters.getItemFromMovemenIfNecessary(product, "line_number")

    const movement = {
      uuid: product?.movement?.value || FIRST_MOVEMENT.uuid,
      plan_uuid: product?.uuid,
      iccid: ICCID,
      line_number: LINE_NUMBER.replace(/\D/g,"") || null
    }

    const altaMovement = FIRST_MOVEMENT?.available_movements.find(
      ({ description }) => description === MOVEMENT_TYPES.alta
    )

    if (movement?.uuid === altaMovement.uuid) {
      movement.portability = getters.getItemFromMovemenIfNecessary(product, "portability") === PORTABILITY.yes

      if (movement.portability) {
        movement.current_phone_provider = getters.getItemFromMovemenIfNecessary(product, "current_phone_provider")
      }

      if (product.simcard_type) {
        movement.simcard_type = getters.getItemFromMovemenIfNecessary(product, "simcard_type")
      }
    }

    const upgradeMovement = FIRST_MOVEMENT?.available_movements.find(
      ({ description }) => description === MOVEMENT_TYPES.upgrade
    )
    const downgradeMovement = FIRST_MOVEMENT?.available_movements.find(
      ({ description }) => description === MOVEMENT_TYPES.downgrade
    )

    if (
      (upgradeMovement && movement?.uuid === upgradeMovement.uuid) ||
      (downgradeMovement && movement?.uuid === downgradeMovement.uuid)
    ) {
      const currentPlan = getters.getItemFromMovemenIfNecessary(product, "current_plan")
      if (currentPlan) {
        movement.current_plan = currentPlan
      }
    }

    return movement
  },

  getAdditionalServicePayload: () => product => ({
    uuid: product.service_uuid,
    status_id: product.status_id,
    service_additional: {
      uuid: product.uuid
    },
    status_reason_uuid: product.status_reason.uuid
  }),

  getIsPackageWithMovements: () => product => {
    return (
      product.offer_type === SERVICES_TYPES.packaged &&
      product.properties?.movements?.length > 0
    )
  },

  getIsMobileWithMovements: () => product => {
    return (
      product.offer_type === SERVICES_TYPES.plan &&
      product.type === CATEGORY_TYPES.mobile &&
      product.properties?.movements?.length > 0
    )
  },

  getPlanPayload: () => product => ({
    uuid: product.service_uuid,
    status_id: product.status_id,

    dependents: [
      ...(product.dependents?.free || []),
      ...(product.dependents?.paid || [])
    ].map(dependent => ({
      uuid: dependent.uuid,
      movement: dependent.movement?.value,
      portability: dependent.portability === PORTABILITY.yes,
      current_line: dependent.line_number
        ? dependent.line_number.replace(/\D/g, "")
        : null,
      carrier: dependent.current_phone_provider || null,
      iccid: dependent.iccid || null
    })),

    plan: {
      uuid: product.uuid
    },

    status_reason_uuid: product.status_reason.uuid
  }),

  getAllServicesApproved: (state, getters) => (services) => {
    return services.map(service => ({
      ...service,
      status_id: getters.statusApproved,
      status: SERVICE_STATUS_NAME.approved,
    }))
  },

  getAllServicesDisapproved: (state, getters) => (services) => {
    return services.map(service => ({
      ...service,
      status_id: getters.statusReproved,
      status: SERVICE_STATUS_NAME.reproved,
    }))
  },
}
